import { Stack, Text, Spacer } from '@backyard-ui/core';
import { Checkmark } from '@backyard-ui/icons';

import { type Review } from '@/infra/services/catalog/review/model';

import { CrossIcon } from './CrossIcon';

interface RecommendationProps extends Pick<Review, 'isRecommended'> {}

function Recommendation(props: RecommendationProps) {
  const { isRecommended = false } = props;

  return (
    <Stack direction="row" spacing="0" align="center">
      <Text size="lg">Recomenda esse produto</Text>
      <Spacer size="3" />
      {isRecommended ? (
        <Checkmark height={16} width={16} data-testid="checkmark-icon" />
      ) : (
        <CrossIcon data-testid="cross-icon" />
      )}
      <Spacer size="2" />
      <Text size="lg">{isRecommended ? 'Sim' : 'Não'}</Text>
    </Stack>
  );
}

export default Recommendation;
